// src/App.js
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useEffect, useState } from "react";

import Layout from "./components/Layout.jsx";
import AboutLayout from "./components/AboutLayout.jsx";
import SubLayout from "./components/SubLayout.jsx";

import HomePage from "./pages/HomePage.jsx";
import AboutPage from "./pages/AboutPage.jsx";
import InstructorsPage from "./pages/InstructorsPage.jsx";
import PartnersPage from "./pages/PartnersPage.jsx";
import CentersPage from "./pages/CentersPage.jsx";

import CoursesPage from "./pages/CoursesPage.jsx";
import CoursePlacesPage from "./pages/CoursePlacesPage.jsx";
import SchedulePage from "./pages/SchedulePage.jsx";
import InquiryPage from "./pages/InquiryPage.jsx";

import NoticeLayout from "./components/NoticeLayout.jsx";
import NoticeListPage from "./pages/NoticeListPage.jsx";
import FaqPage from "./pages/FaqPage.jsx";

import AdminPage from "./pages/AdminPage.jsx"; // ✅ 관리자 페이지 추가

import "./styles/globals.css";
import "./styles/home.css";
import "./styles/header.css";
import "./styles/footer.css";
import "./styles/about.css";
import "./styles/social-icons.css";
import "./styles/courses.css";
import "./styles/course-places.css";
import "./styles/schedule.css";

export default function App() {
  const [data, setData] = useState(null);

  useEffect(() => {
    (async () => {
      const res = await fetch("/content.json", { cache: "no-cache" });
      const json = await res.json();
      setData(json);
    })().catch(console.error);
  }, []);

  if (!data) return null;

  return (
    <Router>
      <Layout data={data}>
        <Routes>
          {/* 메인 */}
          <Route path="/" element={<HomePage data={data} />} />

          {/* 회사소개 */}
          <Route
            path="/about"
            element={
              <AboutLayout data={data}>
                <AboutPage data={data} />
              </AboutLayout>
            }
          />
          <Route
            path="/instructors"
            element={
              <AboutLayout data={data}>
                <InstructorsPage data={data} />
              </AboutLayout>
            }
          />
          <Route
            path="/partners"
            element={
              <AboutLayout data={data}>
                <PartnersPage data={data} />
              </AboutLayout>
            }
          />
          <Route
            path="/centers"
            element={
              <AboutLayout data={data}>
                <CentersPage data={data} />
              </AboutLayout>
            }
          />

          {/* 강습/과정 */}
          <Route path="/courses" element={<CoursesPage data={data} />} />
          <Route path="/places" element={<CoursePlacesPage data={data} />} />

          {/* 일정 / 문의 */}
          <Route
            path="/schedule"
            element={
              <SubLayout data={data} title="강습 일정">
                <SchedulePage />
              </SubLayout>
            }
          />
          <Route
            path="/inquiry"
            element={
              <SubLayout data={data} title="강습 문의">
                <InquiryPage />
              </SubLayout>
            }
          />

          {/* 고객센터 */}
          <Route
            path="/notice"
            element={
              <NoticeLayout data={data}>
                <NoticeListPage />
              </NoticeLayout>
            }
          />
          <Route
            path="/faq"
            element={
              <NoticeLayout data={data}>
                <FaqPage />
              </NoticeLayout>
            }
          />

          {/* ✅ 관리자 페이지 (/admin) */}
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
      </Layout>
    </Router>
  );
}
